import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-cash-receipt-preview',
  templateUrl: './cash-receipt-preview.component.html',
  styleUrls: ['./cash-receipt-preview.component.scss']
})
export class CashReceiptPreviewComponent implements OnInit {
  pdf_data: any = null;
  constructor(public dialogRef: MatDialogRef<CashReceiptPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private domSanitizer: DomSanitizer) {
    console.log(data)
    this.pdf_data = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);

  }


  closeComponent() {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
